/**
 * سوالات متداول مرکزی — پاسخ‌ها جنبهٔ آموزشی و راهنمایی کلی دارند
 * و جایگزین مشاورهٔ فردی، درمان یا مداخلهٔ اورژانسی نیستند.
 */

export type FaqCategoryId =
  | 'family_relations'
  | 'inner_growth'
  | 'work_money'
  | 'concepts'
  | 'audio_packages'
  | 'account_tech';

export type FaqCategoryMeta = {
  id: FaqCategoryId;
  label: string;
  shortLabel: string;
  description: string;
};

export const FAQ_CATEGORIES: FaqCategoryMeta[] = [
  {
    id: 'family_relations',
    label: 'خانواده و روابط',
    shortLabel: 'روابط',
    description: 'همسر، فرزندان، مرزها و ارتباط سالم',
  },
  {
    id: 'inner_growth',
    label: 'رشد درونی و احساسات',
    shortLabel: 'رشد درونی',
    description: 'اضطراب، باورها، انگیزه و مسیر شخصی',
  },
  {
    id: 'work_money',
    label: 'شغل و مالی',
    shortLabel: 'شغل و مالی',
    description: 'درآمد، کار و مسیر شغلی',
  },
  {
    id: 'concepts',
    label: 'مفاهیم آموزشی',
    shortLabel: 'مفاهیم',
    description: 'باگ، سناریو، نامه‌ها و تکنیک‌ها',
  },
  {
    id: 'audio_packages',
    label: 'بسته‌های صوتی',
    shortLabel: 'بسته‌ها',
    description: 'نحوهٔ گوش دادن و انتظار از محتوا',
  },
  {
    id: 'account_tech',
    label: 'ورود، پنل و فنی',
    shortLabel: 'پنل',
    description: 'رمز، پخش آنلاین و فعال‌سازی',
  },
];

export type FaqItem = {
  id: string;
  categoryId: FaqCategoryId;
  question: string;
  answer: string;
  /** کلمات اضافه برای جستجو (مترادف، موضوع خام کاربر) */
  keywords?: string[];
};

export const FAQ_ITEMS: FaqItem[] = [
  {
    id: 'f-01',
    categoryId: 'inner_growth',
    question: 'چرا سال‌ها در مسیرم بودم ولی به نتیجه‌ای که می‌خواهم نرسیدم؟',
    answer:
      'معمولاً ترکیبی از انتظار نادرست از خودمان، تکرار الگوهای قدیمی بدون بازنگری عمیق، یا تلاش بدون بازخورد درست است. پیشنهاد می‌شود خروجی‌ها را کوچک و قابل اندازه‌گیری کنید، الگوی «تلاش ↔ استراحت ↔ اصلاح مسیر» را جدی بگیرید و اگر احساس می‌کنید در چرخه‌ای گیر کرده‌اید، با یک کوچ یا روان‌درمانگر معتبر مسیر را بازبینی کنید. محتوای آموزشی می‌تواند چارچوب بدهد اما جایگزین همراهی تخصصی نیست.',
    keywords: ['پیشرفت', '۵ سال', 'مسیر'],
  },
  {
    id: 'f-02',
    categoryId: 'family_relations',
    question: 'همسرم سال‌هاست به من خیانت می‌کند ولی نمی‌توانم جدا شوم؛ چه کنم؟',
    answer:
      'این وضعیت هم سنگین است هم خطرناک برای سلامت روان و گاه امنیت جسمی. اولویت با امنیت شماست: حد مرز مشخص، حمایت حقوقی در صورت نیاز، و مشاورهٔ تخصصی خانواده یا روان‌درمانگر. تصمیم ماندن یا جدایی حق شماست؛ ترس از قضاوت دیگران نباید تنها معیار باشد. در کنار کار درونی، حتماً از پشتیبانی حرفه‌ای واقعی استفاده کنید.',
    keywords: ['خیانت', 'طلاق', 'همسر'],
  },
  {
    id: 'f-03',
    categoryId: 'family_relations',
    question: 'فرزندم خیلی عصبی است و من ناراحتم؛ چطور کمکش کنم؟',
    answer:
      'عصبانیت کودک اغلب زبانِ فشار، خستگی، یا نیاز به مرز و امنیت است. آرام ماندن شما، کاهش رقابت کلامی در لحظهٔ بحران، و بعد از آرام شدن، گفتگوی کوتاه و مشخص مؤثرتر از سرزنش مکرر است. اگر پرخاشگری شدید، افت تحصیلی، یا آسیب به خود/دیگران بود، ارزیابی با روان‌شناس کودک ضروری است.',
    keywords: ['بچه', 'عصبی', 'خشم'],
  },
  {
    id: 'f-04',
    categoryId: 'family_relations',
    question: 'فرزندم اعتیاد دارد و کار نمی‌کند؛ چطور کنارش باشم؟',
    answer:
      'اعتیاد بیماری پیچیده‌ای است؛ «نجات دادن با پول یا تهدید» معمولاً پاسخ پایدار نمی‌دهد. حد مرز سالم، حمایت از درمان تخصصی (مراکز ترک)، و مراقبت از سلامت روانی خودتان مهم است. شما می‌توانید همراه باشید بدون اینکه مسئولیت انتخاب‌های بالغ فرزند را تماماً به دوش بکشید.',
    keywords: ['گل', 'مخدر', 'اعتیاد'],
  },
  {
    id: 'f-05',
    categoryId: 'inner_growth',
    question: 'با گوش دادن به محتوای ثروت، فقر را بیشتر «می‌بینم»؛ طبیعی است؟',
    answer:
      'گاهی آگاهی از باورها و ترس‌های مالی، قبل از تغییر واقعی، حساسیت بیشتری نسبت به کمبود ایجاد می‌کند. این فاز را با اقدام کوچک مالی (بودجه، مهارت، شبکهٔ کاری) همراه کنید؛ اگر اضطراب غیرقابل تحمل شد، با متخصص صحبت کنید. انتظار نداشته باشید فقط با شنیدن، معجزهٔ فوری رخ دهد.',
    keywords: ['ذهن ثروتمند', 'فقر'],
  },
  {
    id: 'f-06',
    categoryId: 'inner_growth',
    question: 'نسبت به ظاهر دیگران یا روابط عاطفی، حس بد و مقایسه می‌گیرم؛ چرا؟',
    answer:
      'مقایسه و واکنش احساسی اغلب از نیاز به تایید، کمبود امنیت درونی، یا تجربه‌های قدیمی می‌آید. کار روی خودارزشمندی، مرزهای سالم در روابط، و در صورت تکرار الگو، روان‌درمانی می‌تواند کمک کند. محتوای آموزشی می‌تواند آغازگر باشد، نه پایان مسیر.',
    keywords: ['خوشتیپ', 'قدرت', 'دختر'],
  },
  {
    id: 'f-07',
    categoryId: 'family_relations',
    question: 'با همسرم نمی‌توانم رابطهٔ جنسی برقرار کنم یا او سرد و بی‌توجه است.',
    answer:
      'علت‌ها از استرس و خستگی تا تعارض عاطفی، دارو، یا مسائل پزشکی متفاوت است. گفتگوی صادقانه در فضای امن (بدون سرزنش) و در صورت ادامه، مشاور جنسی یا پزشک مرتبط توصیه می‌شود. هر دو طرف باید تمایل به حل مسئله داشته باشند.',
    keywords: ['جنسی', 'سرد', 'توجه'],
  },
  {
    id: 'f-08',
    categoryId: 'family_relations',
    question: 'همسرم مرا تحقیر می‌کند (گاه با خشونت) ولی جدا نمی‌شوم؛ ترسم از آبرو و قضاوت است.',
    answer:
      'تحقیر و خشونت خط قرمز است؛ ترس از قضاوت نباید شما را در معرض آسیب نگه دارد. مستندسازی، مشاورهٔ حقوقی، و حمایت روانی ضروری است. ماندن «به خاطر عشق» وقتی امنیت روانی شما نابود می‌شود، معمولاً به معنای سلامت رابطه نیست — انتخاب آگاهانه با پشتیبانی حرفه‌ای لازم است.',
    keywords: ['تحقیر', 'کتک', 'آبروریزی'],
  },
  {
    id: 'f-09',
    categoryId: 'family_relations',
    question: 'فرزندم با من دعوا کرده و خانه را ترک کرده؛ چه کنم؟',
    answer:
      'اگر نگران ایمنی او هستید، با مراجع قانونی یا اورژانس اجتماعی طبق شرایط منطقه تماس بگیرید. اگر خطر فوری نیست، پس از آرامش، پیام کوتاه محترمانه و پیشنهاد گفتگو در محیط بی‌طرف بهتر از تعقیب مداوم است. مشاور خانواده می‌تواند نقش میانجی را داشته باشد.',
    keywords: ['خانه', 'رفت'],
  },
  {
    id: 'f-10',
    categoryId: 'family_relations',
    question: 'چرا دخترم زیاد جیغ می‌زند وقتی با میلش رفتار نمی‌کنم؟',
    answer:
      'جیغ در کودکان اغلب بیان ناتوانی در تنظیم هیجان است، نه «لجبازی محض». الگوی شما در واکنش، ثبات قوانین خانه، و خواب/تغذیه نقش دارد. قانون ساده: در بحران بحث نکنید؛ بعداً توضیح دهید. اگر شدت بالاست، ارزیابی تخصصی کمک می‌کند.',
    keywords: ['جیغ', 'دختر'],
  },
  {
    id: 'f-11',
    categoryId: 'family_relations',
    question: 'مادرم پدرم را تحقیر می‌کند و حالم بد می‌شود.',
    answer:
      'شما فرزند هستید، نه درمانگر والدین. می‌توانید مرز بگذارید (مثلاً از بحث‌های سمی خارج شوید) و برای خودتان حمایت بگیرید. اگر امکان مشاورهٔ زوج‌درمانی برای والدین هست، پیشنهاد دهید؛ در غیر این صورت تمرکز بر سلامت روانی خودتان اولویت دارد.',
    keywords: ['مادر', 'پدر', 'تحقیر'],
  },
  {
    id: 'f-12',
    categoryId: 'work_money',
    question: 'از شغلم راضی نیستم چون درآمد خوبی ندارد.',
    answer:
      'ابتدا نیاز مالی واقعی و مهارت‌های قابل فروش را مشخص کنید: ارتقا در همان شغل، شغل دوم کنترل‌شده، یا مهاجرت شغلی تدریجی. ترس از شکست طبیعی است؛ با قدم‌های کوچک و بازخورد بازار جلو بروید. دوره‌های آموزشی می‌توانند جهت بدهند، اما جایگزین تجربهٔ بازار و شبکه‌سازی نیستند.',
    keywords: ['درآمد', 'شغل'],
  },
  {
    id: 'f-13',
    categoryId: 'inner_growth',
    question: 'نمی‌توانم از کسی کمک بگیرم و وقتی کسی می‌خواهد کمک کند حالم بد می‌شود.',
    answer:
      'این می‌تواند ناشی از شرم، کنترل‌گری درونی، یا تجربهٔ گذشتهٔ آسیب‌زا باشد. کمک گرفتن مهارت است؛ با درخواست‌های کوچک و امن شروع کنید. اگر واکنش بدن شدید است، روان‌درمانی برای کار روی دلبستگی و شرم مؤثرتر از توصیهٔ کلی است.',
    keywords: ['کمک', 'حالم بد'],
  },
  {
    id: 'f-14',
    categoryId: 'work_money',
    question: 'کسب‌وکار دارم ولی مشتری کم است؛ چه کنم؟',
    answer:
      'بازبینی محصول/قیمت، مکان، بازاریابی محلی، و تجربهٔ مشتری. گاهی مشکل «تقاضا» نیست بلکه «دیده شدن» یا «اعتماد» است. از اعداد واقعی (فروش روزانه، تبدیل بازدید به خرید) استفاده کنید و یک آزمایش کوچک در هفته تعریف کنید.',
    keywords: ['مغازه', 'فست فود', 'دخل'],
  },
  {
    id: 'f-15',
    categoryId: 'concepts',
    question: 'نامه‌ها را بنویسم دقیقاً چه اتفاقی می‌افتد؟',
    answer:
      'نامه‌نویسی آموزشی معمولاً برای آوردن احساسات و خاطرات به آگاهی، تفکیک نقش‌ها، و تخلیهٔ هیجانی تحت یک چارچوب است؛ جادوی فوری برای تغییر دیگران یا شرایط بیرونی تضمین نمی‌شود. اثر پایدار وقتی است که با درک، تکرار هوشمندانه، و در صورت نیاز همراهی تخصصی همراه شود.',
    keywords: ['نامه', 'نوشتن'],
  },
  {
    id: 'f-16',
    categoryId: 'concepts',
    question: '«تغییر سناریو» یعنی چه؟ همان رویاپردازی است؟',
    answer:
      'تغییر سناریو در آموزش‌های این مسیر معمولاً به معنای بازنویسی ذهنی داستان قدیمی (باور، ترس، نقش) در قالب هدفمند است، نه پرش تصادفی بین خیال‌ها. تفاوت در انضباط، هدف، و اتصال به اقدام واقعی است؛ جزئیات دقیق هر دوره را در همان محتوا دنبال کنید.',
    keywords: ['سناریو', 'رویا'],
  },
  {
    id: 'f-17',
    categoryId: 'family_relations',
    question: 'از همسرم جدا شدم ولی حالم بد است / دوست دارم برگردد؛ طبیعی است؟',
    answer:
      'سوگ رابطه، عادت، ترس از آینده، و حتی تناقض احساسی بعد از جدایی شایع است. به بدن و خواب خودتان برسید، شبکهٔ حمایتی بسازید، و اگر افسردگی شدید یا افکار آسیب‌زا دارید، فوراً با متخصص تماس بگیرید. تصمیم برای بازگشت باید بر پایهٔ امنیت و احترام متقابل باشد، نه فقط دلتنگی.',
    keywords: ['طلاق', 'برگشت', 'حالم بده'],
  },
  {
    id: 'f-18',
    categoryId: 'inner_growth',
    question: 'روی وابستگی کار می‌کنم ولی سردرد و تهوع دارم؛ علت چیست؟',
    answer:
      'علائم جسمی می‌تواند اضطراب، کم‌آبی، کمبود خواب، یا علت پزشکی باشد. اگر شدید یا پایدار است، حتماً پزشک عمومی یا متخصص مغز و اعصاب را ببینید. در کنار آن، کاهش تلاش اجباری بدون استراحت و همراهی با درمانگر، از تشدید علائم جلوگیری می‌کند.',
    keywords: ['وابستگی', 'سردرد', 'تهوع'],
  },
  {
    id: 'f-19',
    categoryId: 'concepts',
    question: '«باگ» در این آموزش‌ها یعنی چه؟',
    answer:
      'به‌صورت تشبیهی، باگ یعنی باور، ترس، یا الگوی ذهنی که زیر تصمیم‌ها و احساس‌های شما را خراب می‌کند بدون اینکه همیشه آشکار باشد. شناسایی باگ هدف است؛ رفع آن نیاز به تمرین، زمان، و گاه روان‌درمانی دارد.',
    keywords: ['باگ', 'خطا'],
  },
  {
    id: 'f-20',
    categoryId: 'concepts',
    question: '«همه‌چیز از آن من است و هیچ‌چیز از آن من نیست» یعنی چه؟',
    answer:
      'معمولاً به تناقض آگاهی دربارهٔ کنترل و تسلیم اشاره دارد: بخشی از تجربه را می‌توان با مسئولیت‌پذیری ساخت، بخشی خارج از ارادهٔ مستقیم ماست. معنای دقیق در همان درس/کارگاه توضیح داده شده؛ از تعبیر سطحی که به بی‌مسئولیتی یا سرزنش خود منجر شود، پرهیز کنید.',
    keywords: ['از آن من', 'نیست'],
  },
  {
    id: 'f-21',
    categoryId: 'concepts',
    question: 'فقط اطلاعات جمع می‌کنم و انبار می‌کنم ولی اجرا نمی‌کنم؛ چرا؟',
    answer:
      'شایع‌ترین علت‌ها: ترس از شکست، کمال‌گرایی، یا اینکه «یادگیری» جایگزین ناخودآگاه «اقدام» شده است. قانون ساده: به ازای هر واحد مصرف محتوا، یک خروجی کوچک تعریف کنید (نوشتن، تماس، تمرین ۱۰ دقیقه‌ای). اگر اجرا برایتان غیرممکن به نظر می‌رسد، ریشهٔ ترس را با متخصص بررسی کنید.',
    keywords: ['انبار', 'جمع'],
  },
  {
    id: 'f-22',
    categoryId: 'inner_growth',
    question: 'مشاور زیاد رفتم ولی مشکلم حل نشد و خیلی شکاکم.',
    answer:
      'گاهی نیاز به رویکرد دیگر، درمانگر دیگر، یا تشخیص دقیق‌تر (اضطراب، وسواس، تروما) است. شکاکی مزمن می‌تواند علامت بالینی باشد؛ روان‌پزشک یا روان‌شناس بالینی می‌تواند ارزیابی کند. محتوای آموزشی مکمل است، نه جایگزین درمان.',
    keywords: ['شکاک', 'روانشناس'],
  },
  {
    id: 'f-23',
    categoryId: 'inner_growth',
    question: 'چرا در شکست‌ها می‌مانم و حرکت نمی‌کنم یا ذهنم در بدبینی قفل شده؟',
    answer:
      'خستگی ذهنی، ترس از تکرار آسیب، یا افسردگی می‌تواند سیستم انگیزش را کم کند. حرکت خیلی کوچک (بدون نیاز به انگیزهٔ کامل)، حمایت اجتماعی، و در صورت ادامهٔ علائم، مراجعهٔ تخصصی ضروری است.',
    keywords: ['شکست', 'بدبینی', 'قفل'],
  },
  {
    id: 'f-24',
    categoryId: 'inner_growth',
    question: 'چطور از اضطراب مداوم یا وسواس شدید در کارهای روزمره رها شوم؟',
    answer:
      'اضطراب و وسواس اغلب نیازمند ترکیب آموزش مهارت (تنفس، بازسازی شناختی)، و در موارد متوسط تا شدید، درمان شناختی-رفتاری یا دارو تحت نظر پزشک است. اگر علائم زندگی را مختل کرده، منتظر «حل شدن با تلاش ذهنی خالص» نمانید.',
    keywords: ['اضطراب', 'وسواس'],
  },
  {
    id: 'f-25',
    categoryId: 'inner_growth',
    question: 'گاهی به خودکشی فکر می‌کنم و انگیزه‌ای ندارم؛ چه کنم؟',
    answer:
      'این وضعیت اورژانس روانی است. همین الان با نزدیک‌ترین فرد مورد اعتماد تماس بگیرید یا به اورژانس بیمارستان مراجعه کنید. در ایران می‌توانید از خطوط مشاورهٔ تلفنی اورژانس اجتماعی (مثلاً ۱۲۳) یا مراکز مشاورهٔ اورژانس روانی که در شهر شما فعال است کمک بگیرید. محتوای وب‌سایت جایگزین مداخلهٔ فوری نیست.',
    keywords: ['خودکشی', 'افسردگی', 'انگیزه'],
  },
  {
    id: 'f-26',
    categoryId: 'inner_growth',
    question: 'چطور رابطه‌ام با خدا را سالم کنم وقتی از سرنوشتم رنجش دارم؟',
    answer:
      'تناقض ایمان و رنج طبیعی است. گفتگوی صادقانه، کاهش مقایسه با دیگران، و همراهی معنوی/روانی می‌تواند کمک کند. اگر احساس گناه یا خشم مزمن مانع زندگی شده، با روان‌درمانگر آشنا به مسائل معنوی/مذهبی خودتان صحبت کنید.',
    keywords: ['خدا', 'رنجش', 'سرنوشت'],
  },
  {
    id: 'f-27',
    categoryId: 'family_relations',
    question: 'چطور با فرزند پرخشم یا حرف‌گوش‌نکن رفتار کنم؟',
    answer:
      'ثبات قانون، پیش‌بینی‌پذیری، و جداییِ «رفتار بد» از «ارزش فرزند». در بحران صدا را پایین بیاورید و بعداً توضیح دهید. اگر خشونت یا آسیب هست، کمک تخصصی نوجوان ضروری است.',
    keywords: ['پسر', 'خشم'],
  },
  {
    id: 'f-28',
    categoryId: 'family_relations',
    question: 'همسرم مسئولیت‌پذیر نیست و کار نمی‌کند.',
    answer:
      'ابتدا علت (افسردگی، اعتیاد، یا انتخاب) را با گفتگو و در صورت امکان مشاور مشخص کنید. مرز مالی و مسئولیت خانه باید شفاف باشد؛ «تحمل بی‌نهایت» معمولاً مشکل را بزرگ‌تر می‌کند. در موارد آسیب، مشاورهٔ حقوقی لازم است.',
    keywords: ['مسئولیت', 'کار نمی‌کند'],
  },
  {
    id: 'f-29',
    categoryId: 'inner_growth',
    question: 'در روابط از من سوءاستفاده می‌شود یا خیانت می‌بینم؛ چرا تکرار می‌شود؟',
    answer:
      'الگوهای انتخاب شریک، مرز ضعیف، یا باورهای قدیمی دربارهٔ عشق می‌تواند نقش داشته باشد. روان‌درمانی برای الگوهای دلبستگی و خودارزشمندی مؤثر است. هیچ‌کس مستحق سوءاستفاده نیست؛ مسئولیت رفتار آسیب‌زا با فرد آسیب‌زاست.',
    keywords: ['سوءاستفاده', 'خیانت'],
  },
  {
    id: 'f-30',
    categoryId: 'inner_growth',
    question: 'چطور کسانی را که آزارم داده‌اند ببخشم وقتی هنوز حالم از یادآوری بد می‌شود؟',
    answer:
      'بخشش به معنای توجیه آسیب یا اجبار به ارتباط نیست؛ گاهی «رها کردن از نظر روانی» بدون ارتباط، هدف است. این کار سخت است و زمان می‌برد؛ با روان‌درمانگر تروما پیش بروید. اگر تجاوز در کودکی بوده، حتماً با متخصص تروما کار کنید.',
    keywords: ['بخشش', 'آزار', 'تجاوز'],
  },
  {
    id: 'f-31',
    categoryId: 'inner_growth',
    question: 'چرا در ارتباط با مردم قدرت کلام کافی ندارم یا از بحث فرار می‌کنم؟',
    answer:
      'اغلب ترس از تعارض، شرم، یا تجربهٔ تنبیه در گذشته. تمرین مهارت‌های assertiveness کوچک در محیط امن و سپس گسترش تدریجی کمک می‌کند. دوره‌های ارتباطی مکمل‌اند.',
    keywords: ['کلام', 'دفاع', 'فرار'],
  },
  {
    id: 'f-32',
    categoryId: 'concepts',
    question: 'با وجود انجام تکنیک‌ها هنوز تغییر زیادی نمی‌بینم؛ علت چیست؟',
    answer:
      'انتظار خطی از نتیجه، عمق مسئله، نبود همراهی تخصصی، یا اجرای ناقص تمرین‌ها. گاهی «بدتر شدن موقت» بخشی از آشکار شدن احساسات است، اما اگر ناامیدی شدید یا علائم جسمی شدید شد، با متخصص صحبت کنید. پیشرفت را با معیارهای کوچک بسنجید.',
    keywords: ['تکنیک', 'نتیجه', 'جواب'],
  },
  {
    id: 'f-33',
    categoryId: 'concepts',
    question: 'چرا با جدول سایه‌ها را پیدا نمی‌کنم یا خاطرات برای پاکسازی نمی‌آید؟',
    answer:
      'ذهن برای محافظت گاه خاطرات را مسدود می‌کند. اجبار به یادآوری ممکن است مضر باشد. با تمرینات همان دوره پیش بروید؛ اگر علائم بدن یا پریشانی شدید، تمرین را با راهنما یا درمانگر هماهنگ کنید.',
    keywords: ['جدول', 'سایه', 'خاطره'],
  },
  {
    id: 'f-34',
    categoryId: 'concepts',
    question: 'لغزش داشتم؛ چطور جلوی تکرار را بگیرم؟',
    answer:
      'لغزش را بدون قضاوت شدید ثبت کنید: تریگر چه بود؟ چه باوری فعال شد؟ برنامهٔ جایگزین برای دفعهٔ بعد بسازید. اگر الگوی اعتیادی است، حتماً از درمان تخصصی استفاده کنید.',
    keywords: ['لغزش', 'عادت'],
  },
  {
    id: 'f-35',
    categoryId: 'concepts',
    question: 'گریه و راز و نیاز با خدا چه تأثیری دارد؟',
    answer:
      'برای بسیاری از افراد، بیان احساس و تسکین هیجانی ایجاد می‌کند. «کارگشایی» به معنای حل فوری همهٔ مشکلات بیرونی نیست، اما می‌تواند بخشی از تنظیم روانی و معنوی باشد.',
    keywords: ['گریه', 'دعا'],
  },
  {
    id: 'f-36',
    categoryId: 'work_money',
    question: 'چرا هرچه تلاش می‌کنم پول به سمت من نمی‌آید؟',
    answer:
      'بازار، مهارت، زمان، شبکه، و باورهای ناخودآگاه دربارهٔ پول همگی دخیلند. خروجی مالی را با اعداد واقعی بسنجید و یک فرضیهٔ قابل آزمایش در هفته تعریف کنید. اگر احساس «بلوک» شدید، ترکیب کوچینگ مالی و روان‌درمانی می‌تواند کمک کند.',
    keywords: ['پول', 'تلاش'],
  },
  {
    id: 'f-37',
    categoryId: 'inner_growth',
    question: 'علت یبوست یا علائم جسمی از نظر «کار درونی» چیست؟',
    answer:
      'پیوند ذهن و بدن واقعی است، اما علت اولیهٔ پزشکی را نباید نادیده گرفت. ابتدا پزشک؛ سپس در صورت تأیید، بررسی استرس، خواب، و الگوهای غذایی. تفسیر صرف بدون معاینه علمی توصیه نمی‌شود.',
    keywords: ['یبوست', 'بدن'],
  },
  {
    id: 'f-38',
    categoryId: 'work_money',
    question: 'در محیط کار مجبورم کار همکار سطح پایین‌تر را انجام دهم و آزرده می‌شوم.',
    answer:
      'مستندسازی وظایف، مکاتبهٔ رسمی با مدیر، و درخواست شفاف‌سازی نقش. اگر سوءاستفادهٔ سازمانی است، از مسیرهای رسمی شرکت یا قانون کار کمک بگیرید.',
    keywords: ['همکار', 'کار'],
  },
  {
    id: 'f-39',
    categoryId: 'inner_growth',
    question: 'با وجود کار درونی به من تهمت می‌شود؛ چه کنم؟',
    answer:
      'کار درونی مسئولیت رفتار دیگران را برنمی‌دارد. با مستندسازی، شاهد، و مسیر اداری/حقوقی مناسب واکنش نشان دهید. اگر اضطراب شدید دارید، حمایت روانی بگیرید.',
    keywords: ['تهمت', 'شایعه'],
  },
  {
    id: 'p-01',
    categoryId: 'audio_packages',
    question: 'برای شروع بسته‌های صوتی چطور اقدام کنم؟',
    answer:
      'پس از خرید و فعال‌سازی، از پنل کاربری به بخش بسته‌ها بروید؛ ترجیحاً با هدفون در فضای آرام و بدون حواس‌پرتی گوش دهید. یک دفترچهٔ کوچک برای نکات یا تمرین‌ها کنار دست داشته باشید.',
    keywords: ['شروع', 'بسته'],
  },
  {
    id: 'p-02',
    categoryId: 'audio_packages',
    question: 'هنگام گوش دادن باید به سوالات داخل بسته جواب بدهم؟',
    answer:
      'اگر در محتوا تأکید شده، بله — معمولاً برای تعامل ذهنی است. اگر صرفاً شنونده هستید، حداقل توقف کوتاه برای بازتاب ذهنی مفید است.',
    keywords: ['سوال', 'تمرین'],
  },
  {
    id: 'p-03',
    categoryId: 'audio_packages',
    question: 'بستهٔ مشیت را گوش دادم و حالم بدتر شد یا احساس پوچی کردم؛ طبیعی است؟',
    answer:
      'گاهی آگاهی از باورها و تناقض‌ها قبل از تثبیت، ناراحتی موقت ایجاد می‌کند. اگر علائم شدید، پایدار، یا آسیب‌زا بود (بی‌خوابی شدید، افکار آسیب‌زا)، تمرین را متوقف کنید و با پشتیبانی یا متخصص مشورت کنید.',
    keywords: ['مشیت', 'پوچی', 'بدتر'],
  },
  {
    id: 'p-04',
    categoryId: 'audio_packages',
    question: 'بستهٔ مشیت الهی دربارهٔ چیست و بستهٔ ارزشمندی چه تفاوتی دارد؟',
    answer:
      'به‌طور کلی، محتوای «مشیت» بیشتر به تسلیم هوشمندانه، رها کردن کنترل اجباری، و بازتعریف رویدادها می‌پردازد؛ «ارزشمندی» بیشتر به خودارزشمندی، مرز «نه» گفتن، و جایگاه شخصی در روابط تمرکز دارد. برای جزئیات دقیق و نمونه‌های ذکرشده در همان بسته، به فایل‌های همان دوره مراجعه کنید؛ ما در اینجا خلاصهٔ آموزشی می‌دهیم.',
    keywords: ['مشیت', 'ارزشمندی', 'تفاوت'],
  },
  {
    id: 'p-05',
    categoryId: 'audio_packages',
    question: 'باگ‌ها و زخم‌ها را نوشتم؛ بعدش چه کار کنم؟',
    answer:
      'مرحلهٔ بعد معمولاً طبق همان بسته: اولویت‌بندی، تمرین‌های پاکسازی یا بازنویسی، و تکرار منظم است. اگر در دوره مرحلهٔ بعدی مشخص شده، همان را دنبال کنید؛ در غیر این صورت از پشتیبانی محتوا بپرسید.',
    keywords: ['باگ', 'زخم', 'تمرین'],
  },
  {
    id: 'p-06',
    categoryId: 'audio_packages',
    question: 'بسته را صبح بشنوم یا شب؟ موقع کار در خانه هم می‌توانم گوش دهم؟',
    answer:
      'زمان بستگی به تمرکز شماست؛ صبح برای برنامه‌ریزی روز، شب برای بازتاب. اگر موقع کار حواس‌تان پرت می‌شود، نیمه‌فعال گوش دادن ممکن است ارزش را کم کند؛ نسخهٔ کوتاه‌تر یا زمان اختصاصی بهتر است.',
    keywords: ['صبح', 'شب', 'کار'],
  },
  {
    id: 'p-07',
    categoryId: 'audio_packages',
    question: 'دوره را گوش می‌دهم ولی چیزی عوض نمی‌شود یا چیزی نمی‌فهمم.',
    answer:
      'سرعت یادگیری و عمق مسائل متفاوت است. نکته‌برداری، تکرار بخش‌های دشوار، و انجام تمرین عملی ضروری است. اگر چند بار گوش دادید و همچنان گیجید، از پشتیبانی بخواهید مسیر پیشنهادی را شفاف کنند.',
    keywords: ['نمیفهمم', 'تغییر'],
  },
  {
    id: 'p-08',
    categoryId: 'audio_packages',
    question: 'آیا دوره‌ها تکنیک ندارند؟ «ذهن ثروتمند» را بشنوم به درآمد مشخص می‌رسم؟',
    answer:
      'تکنیک‌ها معمولاً داخل همان محتوا یا به‌صورت تمرین‌های هدایت‌شده ارائه می‌شوند؛ انتظار عدد درآمد ثابت قول علمی نیست. درآمد ترکیبی از بازار، مهارت، و اقدام است؛ محتوا جهت می‌دهد.',
    keywords: ['تکنیک', '۱۰۰ میلیون', 'ثروت'],
  },
  {
    id: 'p-09',
    categoryId: 'audio_packages',
    question: '«در ارتعاش ترس» یعنی چه؟ خریدهای روزمره از مشیت خارج می‌کند؟',
    answer:
      'منظور غالباً این است که تصمیم از ترس یا کمبود، نه از آگاهی و انتخاب آگاهانه گرفته می‌شود. خرید و تصمیمات عادی ذاتاً «خارج از مشیت» نیستند؛ کیفیت نیت و اضطراب پشت تصمیم مهم است. برای قواعد دقیق همان آموزش، به متن همان بسته مراجعه کنید.',
    keywords: ['ارتعاش', 'ترس', 'قرض', 'سیب'],
  },
  {
    id: 'p-10',
    categoryId: 'audio_packages',
    question: 'تمرین‌ها را ذهنی انجام دهم یا روی کاغذ؟ نکته‌برداری لازم است؟',
    answer:
      'نوشتن معمولاً وضوح و پیگیری را بیشتر می‌کند؛ برای تمرین‌های عمیق توصیه می‌شود. نکته‌برداری اختیاری اما برای بازبینی هفته‌ها بعد بسیار مفید است.',
    keywords: ['کاغذ', 'ذهنی', 'نکته'],
  },
  {
    id: 'p-11',
    categoryId: 'audio_packages',
    question: 'چطور بسته‌ها را گوش بدهم که نتیجه بگیرم؟ چرا گوش دادن مشکلم را حل نکرده؟',
    answer:
      'برنامهٔ هفتگی ثابت، انجام تمرین، و اتصال به یک اقدام واقعی در زندگی. اگر انتظار دارید صرفاً با شنیدن، مسائل پیچیدهٔ خانوادگی یا مالی حل شود، احتمالاً انتظار را بالا برده‌اید؛ ترکیب با اقدام و حمایت تخصصی لازم است.',
    keywords: ['نتیجه', 'حل نشد'],
  },
  {
    id: 'a-01',
    categoryId: 'account_tech',
    question: 'چرا دوره‌ها دانلود نمی‌شوند؟ باید آنلاین گوش بدهم؟',
    answer:
      'معمولاً محتوا با لایسنس آنلاین ارائه می‌شود تا از کپی غیرمجاز جلوگیری شود. پخش از داخل پنل کاربری با اینترنت پایدار توصیه می‌شود؛ اگر گزینهٔ آفلاین در آینده اضافه شود، در راهنمای همان محصول اعلام می‌شود.',
    keywords: ['دانلود', 'آنلاین'],
  },
  {
    id: 'a-02',
    categoryId: 'account_tech',
    question: 'رمز عبور را چطور وارد کنم؟ فارسی یا انگلیسی؟ حروف کوچک یا بزرگ؟',
    answer:
      'رمز را دقیقاً همان‌طور که هنگام ثبت‌نام ساخته‌اید وارد کنید؛ زبان و حروف بزرگ/کوچک برای سیستم فرق دارد. اگر کیبورد فارسی است، مطمئن شوید حروف انگلیسیِ رمز با حالت صحیح وارد می‌شود. در صورت شک، بازیابی رمز را از صفحهٔ ورود امتحان کنید.',
    keywords: ['رمز', 'پسوورد', 'فارسی'],
  },
  {
    id: 'a-03',
    categoryId: 'account_tech',
    question: 'ورود با رمز عبور بهتر است یا ورود با کد یک‌بار مصرف؟',
    answer:
      'هر دو معتبرند؛ کد برای وقتی که رمز را فراموش کرده‌اید یا روی دستگاه عمومی هستید راحت‌تر است. رمز قوی برای استفادهٔ روزمره روی دستگاه شخصی مناسب است.',
    keywords: ['کد تایید', 'ورود'],
  },
  {
    id: 'a-04',
    categoryId: 'account_tech',
    question: 'چطور وارد پنل شوم؟ از کدام گزینه استفاده کنم؟',
    answer:
      'از منوی سایت «ورود / ثبت‌نام» یا «پیشخوان» را بزنید، شماره یا ایمیل ثبت‌شده را وارد کنید و مراحل را کامل کنید. اگر قبلاً ثبت‌نام کرده‌اید، گزینهٔ ورود را انتخاب کنید نه ثبت‌نام مجدد.',
    keywords: ['پنل', 'داشبورد', 'کروم'],
  },
  {
    id: 'a-05',
    categoryId: 'account_tech',
    question: 'روی اپیزود صدا نمی‌آید یا وسط پخش قطع می‌شود.',
    answer:
      'مرورگر را به‌روز کنید، کش را خالی کنید، حالت ناشناس را امتحان کنید، یا مرورگر دیگر (ترجیحاً کروم). اتصال اینترنت پایدار و غیرفعال بودن بلاکر تبلیغات روی دامنهٔ سایت را بررسی کنید. اگر فقط یک اپیزود مشکل دارد، به پشتیبانی اطلاع دهید.',
    keywords: ['صدا', 'قطع', 'پخش'],
  },
  {
    id: 'a-06',
    categoryId: 'account_tech',
    question: 'رمز را عوض نکردم ولی خطای رمز می‌دهد / می‌گوید ثبت‌نام نشده‌اید.',
    answer:
      'اشتباه تایپی، زبان کیبورد، یا حساب دیگری با همان شماره. بازیابی رمز و بررسی شمارهٔ واردشده. اگر با لینک خاصی آمده‌اید، مطمئن شوید همان حساب خریدار است.',
    keywords: ['خطا', 'user'],
  },
  {
    id: 'a-07',
    categoryId: 'account_tech',
    question: 'صفحهٔ پنل را بوکمارک کردم ولی دوباره به ورود می‌رود؛ چرا؟',
    answer:
      'نشست ورود (session) ممکن است منقضی شده باشد یا کوکی مسدود باشد. دوباره وارد شوید و اجازهٔ کوکی برای سایت بدهید. بوکمارک بهتر است آدرس اصلی سایت باشد، نه صفحهٔ موقت تأیید.',
    keywords: ['بوکمارک', 'سیو'],
  },
  {
    id: 'a-08',
    categoryId: 'account_tech',
    question: 'بسته را خریدم و گفته شد تا ۲۴ ساعت فعال می‌شود ولی هنوز فعال نیست.',
    answer:
      'گاهی تأخیر پرداخت یا تطابق شمارهٔ تماس با خرید وجود دارد. رسید پرداخت و شمارهٔ خرید را نگه دارید و با پشتیبانی تماس بگیرید تا دسترسی بررسی شود.',
    keywords: ['۲۴ ساعت', 'فعال', 'شماره'],
  },
  {
    id: 'a-09',
    categoryId: 'account_tech',
    question: 'چطور بسته‌ام را از داشبورد پیدا کنم و گوش بدهم؟',
    answer:
      'پس از ورود، بخش «دوره‌ها / بسته‌ها / خریدهای من» (نام دقیق در رابط کاربری) را باز کنید و روی همان محصول کلیک کنید. اگر آیتمی نمایش داده نمی‌شود، احتمالاً با حساب دیگری وارد شده‌اید.',
    keywords: ['داشبورد', 'گوش'],
  },
];
